:host {
  --title-font-size: 32px;
  --subtitle-font-size: 16px;
  --subtitle-line-height: 26px;
  --title-font-color: #333333;
  --title-font-weight: 600;
  --subtitle-font-weight: 500;
  --title-margin-bottom: 16px;
  --text-align: left;
  --close-icon-size: 32px;

  display: block;
}
@media screen and (max-width: 1024px) {
  :host {
    --title-font-size: 18px;
    --subtitle-font-size: 12px;
    --subtitle-line-height: 18px;
    --title-margin-bottom: 8px;
    --close-icon-size: 18px;
  }
}

.modal-content {
  position: relative;
}

/* modal close icon */
.close-icon {
  box-sizing: border-box;
  position: absolute;
  right: 0;
  top: calc(0px - var(--close-icon-size));
  width: var(--close-icon-size);
  height: var(--close-icon-size);
  padding: 6px;
  cursor: pointer;
  transition: all .2s ease;
  border-radius: 2px;
}
.close-icon path {
  transition: all .2s ease;
}
.close-icon:hover {
  background-color: rgba(0, 0, 0, 0.06);
}
.close-icon:active {
  background-color: rgba(0, 0, 0, 0.15);
}
.close-icon:hover path {
  fill: rgba(0, 0, 0, 0.8);
}
/* modal close icon */

/* modal 标题 */
.modal-title {
  font-size: var(--title-font-size);
  margin-bottom: var(--title-margin-bottom);
  color: var(--title-font-color);
  font-weight: var(--title-font-weight);
  text-align: var(--text-align);
  margin-top: 0;
  padding: 0;
}

.modal-sub-title {
  font-size: var(--subtitle-font-size);
  line-height: var(--subtitle-line-height);
  font-weight: var(--subtitle-font-weight);
  text-align: var(--text-align);
  margin: 0;
  padding: 0;
}
/* modal 标题 */

/* modal footer */
.footer-btns {display: flex;gap:12px;justify-content: flex-end;}
.footer--btn {width: max-content;}
/* modal footer */

@media screen and (max-width: 1024px) {
  .footer-btns {display: flex;gap:12px;justify-content: center;}
  .footer--btn {width: 100%;flex: 1;}
  .close-icon {padding: 2px;border-radius: 2px;top: 0;}
}